import { Action } from '../../common/actions/core/action';

export class ChangePaymentInfoAction implements Action {
  constructor(public onChangePaymentMethodApprove: () => any) {}
}



// WEBPACK FOOTER //
// src/app/buy/change-payment-info-dialog/change-payment-info.action.ts